import { ethers } from "ethers";
import React, { ReactNode, createContext, useEffect, useState } from "react";

export interface AccountType {
  address: string;
  balance: string;
  chainId: string;
  network: string;
  provider: any;
  signer: any;
}

export const AppContext = createContext({
  account: "",
  accountData: {
    address: "",
    balance: "",
    chainId: "",
    network: "",
    provider: undefined,
    signer: undefined,
  },
  connectWallet: async () => {},
  error: "",
});

const { ethereum } = typeof window !== "undefined" ? window : ({} as any);

function AppProvider({ children }: { children: ReactNode }) {
  const [account, setAccount] = useState("");
  const [accountData, setAccountData] = useState<AccountType>({
    address: "",
    balance: "",
    chainId: "",
    network: "",
    provider: undefined,
    signer: undefined,
  });
  const [error, setError] = useState("");

  const checkEthereumExists = () => {
    if (!ethereum) {
      setError("Please Install MetaMask.");
      return false;
    }
    return true;
  };
  const getConnectedAccounts = async () => {
    setError("");
    try {
      const accounts = await ethereum.request({
        method: "eth_accounts",
      });
      // console.log(accounts);
      setAccount(accounts[0]);
      // Create an ethers.js provider using the injected provider from MetaMask
      const provider = new ethers.BrowserProvider(ethereum);
      const signer = await provider.getSigner();
      // Get the account balance
      const balance = await provider.getBalance(accounts[0]);
      // Get the network ID from MetaMask
      const network = await provider.getNetwork();
      setAccountData({
        address: accounts[0],
        balance: ethers.formatEther(balance),
        // The chainId property is a bigint, change to a string
        chainId: network.chainId.toString(),
        network: network.name,
        provider: provider,
        signer: signer,
      });
    } catch (err: any) {
      setError(err.message);
    }
  };
  const connectWallet = async () => {
    setError("");
    if (checkEthereumExists()) {
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        // console.log(accounts);
        setAccount(accounts[0]);
        // Create an ethers.js provider using the injected provider from MetaMask
        const provider = new ethers.BrowserProvider(ethereum);
        const signer = await provider.getSigner();

        // Get the account balance
        const balance = await provider.getBalance(accounts[0]);
        // Get the network ID from MetaMask
        const network = await provider.getNetwork();
        setAccountData({
          address: accounts[0],
          balance: ethers.formatEther(balance),
          // The chainId property is a bigint, change to a string
          chainId: network.chainId.toString(),
          network: network.name,
          provider: provider,
          signer: signer,
        });
      } catch (err: any) {
        setError(err.message);
      }
    }
  };

  useEffect(() => {
    if (checkEthereumExists()) {
      ethereum.on("networkChanged", getConnectedAccounts);
      ethereum.on("accountsChanged", getConnectedAccounts);
      getConnectedAccounts();
    }
    return () => {
      if (checkEthereumExists()) {
        ethereum.removeListener("accountsChanged", getConnectedAccounts);
        ethereum.removeListener("networkChanged", getConnectedAccounts);
      }
    };
  }, []);

  return (
    <AppContext.Provider value={{ account, accountData, connectWallet, error }}>
      {children}
    </AppContext.Provider>
  );
}

export default AppProvider;
